import { Trans } from '@lingui/react/macro';
import { Tag } from '@remarkable/ark-web';

export const ConnectFeatureTag = ({
  hasSubscription,
  isNew = false,
}: {
  hasSubscription: boolean;
  isNew?: boolean;
}) => {
  if (hasSubscription) {
    return isNew ? (
      <Tag variant="success-light">
        <Trans>New</Trans>
      </Tag>
    ) : null;
  }
  return (
    <Tag variant="info-light" className="whitespace-nowrap">
      <Trans>Included with Connect</Trans>
    </Tag>
  );
};
